export default __webpack_public_path__ + "static/media/american-express.b5bd9c41.svg";